import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { computedFrom } from "aurelia-binding";
import { Router } from 'aurelia-router';
import { StringHelper } from '../../../../Code/Helpers/StringHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { BaseView } from 'Common/BaseView';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { AuthService } from 'DataAccessLayer/Services/AuthService';

declare var Swiper;

@autoinject
export class AircraftDetailBaseView extends BaseView {


    @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
    private aircraftData: any = null;
    protected router: Router = null;
    private element: any = null;
    protected dataService: DataService = null;
    private authService: AuthService = null;
    private documents: Array<any> = null;
    private reviewList: Array<any> = [];
    private userName: string = null;
    private isLogged: boolean = false;

    constructor(element: Element, dataService: DataService, router: Router, authService: AuthService) {
        super();
        this.element = element;
        this.dataService = dataService;
        this.authService = authService;
        this.router = router;

        this.userName = this.authService.GetUserInfo().UserName;
        this.isLogged = StringHelper.StringIs(this.userName) && this.userName != 'PublicUser';
    }
    activate(params, routeConfig, $navigationInstruction) {
        this.entityId = params.entityId;
    }
    async bind() {
        let params: any = {
            AircraftId: this.entityId,
            RequestCounter: 1
        }
        let apiResponse: any = await this.dataService.GetSpData('sp_BirdReviewAircraftPhotos', params);
        if (ObjectHelper.ObjectIs(apiResponse) && ObjectHelper.ObjectIs(apiResponse.data)) {
            const spData: any = JSON.parse(JSON.stringify(apiResponse.data));
            if (ObjectHelper.ObjectIs(spData) && ObjectHelper.ArrayIs(spData.Photos)) {
                this.documents = JSON.parse(JSON.stringify(spData.Photos));
            }
        }

        let response1: any = await this.dataService.GetById('Aircraft', this.entityId);
        if (ObjectHelper.ObjectIs(response1) && ObjectHelper.ObjectIs(response1.data)) {
            this.aircraftData = response1.data;
            this.reviewList = [];
            params.RequestCounter = 1;
            params.FilterString = this.aircraftData.TailNumber;
            params.AircraftId = this.entityId;
            params.ClientCookie = Cookies.get('ccuid');
    
            let apiResponse: any = await this.dataService.GetSpData('sp_BirdReviewAircraftFilter', params);
            if (ObjectHelper.ObjectIs(apiResponse) && ObjectHelper.ObjectIs(apiResponse.data)
                && ObjectHelper.ObjectIs(apiResponse.data.ResponseCounter)) {
                console.log(5555, apiResponse.data);
                this.reviewList = JSON.parse(JSON.stringify(apiResponse.data)).TripReview;
            }

        }
    }

    public async ReviewThisTailNo() {
        if (this.isLogged == true) {
            let data = {
                'TailNumber': this.aircraftData.TailNumber
            };
            this.router.navigateToRoute('entityCreateWithExtData', { entityName: 'TripReview', extData: window.btoa(encodeURIComponent(JSON.stringify(data))) });
        }
        else {
            this.router.navigateToRoute('login');
        }
    }

}
